import styles from "./TestHardwareIcon.module.css";

const ICONS = {
    mouse: {
        light: "/assets/images/online-tests/icons/mouse.svg",
        dark: "/assets/images/online-tests/icons-dark/mouse.svg",
    },
    keyboard: {
        light: "/assets/images/online-tests/icons/keyboard.svg",
        dark: "/assets/images/online-tests/icons-dark/keyboard.svg",
    },
};

export default function TestHardwareIcon({ name, className = "", size = 48, alt = "" }) {
    const icon = ICONS[name];
    if (!icon) return null;

    return (
        <span
            className={`${styles.root} ${className}`.trim()}
            style={{ width: size, height: size }}
            aria-hidden={alt ? undefined : true}
        >
            <img src={icon.light} alt={alt} className={styles.light} decoding="async" />
            <img src={icon.dark} alt="" className={styles.dark} decoding="async" />
        </span>
    );
}
